import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import React from "react"
import { Pressable, View } from "react-native"
import { Switch } from "react-native-paper"

const CustomCheckBox = ({ handleCheck, checked, checkBoxColor }) => {
    return (
        <Pressable
            onPress={() => handleCheck(!checked)}
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingHorizontal: 10,
                paddingVertical: 15
            }}
        >
            <Switch
                value={checked}
                onValueChange={(val) => {
                    console.log("✅ Switch clicked:", val)
                    handleCheck(val)
                }}
                color={checkBoxColor ?? baseColors.green.primary}
                style={{ pointerEvents: "auto" }} // <-- crucial pour le clic
            />
            
            

            
        </Pressable>
    )
}

export default CustomCheckBox
